<template>
  <div>
    <h1>Create Author</h1>
    <el-form ref="form"
             :model="form"
             :rules="rules"
             label-width="160px">

      <el-form-item label="Email">
        <el-input v-model="form.email"
                  placeholder="Email">
        </el-input>
      </el-form-item>
      <el-form-item label="Role">
        <el-radio v-model="form.role"
                  label="2">User</el-radio>
        <el-radio v-model="form.role"
                  label="3">Copartner</el-radio>
        <el-radio v-model="form.role"
                  label="1">Admin</el-radio>
      </el-form-item>
      <el-form-item label="CO">
        <el-checkbox-group v-model="form.co">
          <el-checkbox label="MP"
                       name="co"></el-checkbox>
          <el-checkbox label="BEP"
                       name="co"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="AUTHOR NAME">
        <el-input v-model="form.book_name"
                  placeholder="AUTHOR NAME"></el-input>
      </el-form-item>
      <el-form-item label="INCOME TAX AUTHOR NAME">If different from Author Name
        <el-input v-model="form.income_name"
                  placeholder="If different from Author Name"></el-input>
      </el-form-item>

      <el-form-item label="ADDRESS">
            <el-input v-model="form.address"
                      placeholder="ADDRESS"></el-input>
      </el-form-item>

      
      <el-form-item label="Biography">
        <el-input type="textarea"
                  :rows="5"
                  v-model="form.biography"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="onSubmit()">Create</el-button>
        <el-button>Cancel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import AvatarUpload from '../user/AvatarUpload';
export default {
  components: { AvatarUpload },
  data() {
    return {
      form: {
        co: [],
        email: '',
        book_name: '',
        income_name: '',
        biography: '',
        role: '2',
      },
      rules: {
        email: [{ type: 'email', required: true, trigger: 'blur' }],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.axios({
            method: 'post',
            url: `/sign-up`,
            data: this.form,
          })
            .then(res => {
              if (res.status === 201) {
                this.$message({
                  message: 'Create Success',
                  type: 'success',
                });
                this.$router.push(`/admin/${res.data.userID}/profile`);
              }
            })
            .catch(err => {
              var error = err.response;
              if (error.data.type === 'notification') {
                this.$message({
                  message: error.data.message,
                  type: 'error',
                });
              } else if (error.data.type === 'messageBox') {
                this.$confirm(error.data.message, 'info', {
                  confirmButtonText: 'Confirm',
                  cancelButtonText: 'Cancel',
                  type: 'warning',
                })
                  .then(() => {
                    this.axios({
                      method: 'post',
                      url: `/user/${error.data.userID}/recover`,
                    }).then(res => {
                      this.$router.push(`/admin/${error.data.userID}/profile`);
                    });
                  })
                  .catch(() => {});
              }
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/UserCreate.vue